import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import FullScreenDialog from "../../common/FullScreenDialog";
import { useGetLocationListQuery } from "../../../api/locations/locationsApiSlice";
import { setUseCaseLocations } from "../../../redux/slice/booking/bookingSlice";
import { useDispatch } from "react-redux";
import HostBookPage from "./hostBooking/BookLocationPage";
interface KeyHandoverBookingDialogProps {
  open: boolean;
  locationId?: string;
}

const KeyHandoverBookingDialog = (props: KeyHandoverBookingDialogProps) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { returnPage } = location.state || {};

  const { data: locations } = useGetLocationListQuery("keys");

  useEffect(() => {
    if (locations) {
      dispatch(setUseCaseLocations(locations));
    }
  }, [locations]);

  return (
    <FullScreenDialog open={props.open}>
      <HostBookPage returnPage={returnPage} />
    </FullScreenDialog>
  );
};

export { KeyHandoverBookingDialog };
